import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { PopupState } from './types'
import { PopupService } from '../../services/popup/PopupService'

const initialState: PopupState = {
  popupImage: null,
  isPopupActive: true,
  isGetAllPopupsLoading: false,
  isGetPopupByIdLoading: false,
  isCreatePopupLoading: false,
  isUpdatePopupLoading: false,
  isUpdatePopupOrderLoading: false,
  isDeletePopupLoading: false
}

const slice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    togglePopupActive: (state) => {
      state.isPopupActive = !state.isPopupActive
    },
    setPopupImage: (state, action: PayloadAction<File | null>) => {
      state.popupImage = action.payload
    },
    resetPopupState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(PopupService.getAllPopupsAsyncThunk.pending, (state) => {
        state.isGetAllPopupsLoading = true
      })
      .addCase(PopupService.getAllPopupsAsyncThunk.rejected, (state) => {
        state.isGetAllPopupsLoading = false
      })
      .addCase(PopupService.getAllPopupsAsyncThunk.fulfilled, (state, action) => {
        state.isGetAllPopupsLoading = false
        state.popups = action.payload
      })
      .addCase(PopupService.getPopupByIdAsyncThunk.pending, (state) => {
        state.isGetPopupByIdLoading = true
      })
      .addCase(PopupService.getPopupByIdAsyncThunk.rejected, (state) => {
        state.isGetPopupByIdLoading = false
      })
      .addCase(PopupService.getPopupByIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetPopupByIdLoading = false
        state.popup = action.payload.popup
        state.isPopupActive = action.payload.popup.isActive
      })
      .addCase(PopupService.createPopupAsyncThunk.pending, (state) => {
        state.isCreatePopupLoading = true
      })
      .addCase(PopupService.createPopupAsyncThunk.rejected, (state) => {
        state.isCreatePopupLoading = false
      })
      .addCase(PopupService.createPopupAsyncThunk.fulfilled, (state) => {
        state.isCreatePopupLoading = false
      })
      .addCase(PopupService.updatePopupAsyncThunk.pending, (state) => {
        state.isUpdatePopupLoading = true
      })
      .addCase(PopupService.updatePopupAsyncThunk.rejected, (state) => {
        state.isUpdatePopupLoading = false
      })
      .addCase(PopupService.updatePopupAsyncThunk.fulfilled, (state) => {
        state.isUpdatePopupLoading = false
      })
      .addCase(PopupService.updatePopupOrderAsyncThunk.pending, (state) => {
        state.isUpdatePopupOrderLoading = true
      })
      .addCase(PopupService.updatePopupOrderAsyncThunk.rejected, (state) => {
        state.isUpdatePopupOrderLoading = false
      })
      .addCase(PopupService.updatePopupOrderAsyncThunk.fulfilled, (state) => {
        state.isUpdatePopupOrderLoading = false
      })
      .addCase(PopupService.deletePopupAsyncThunk.pending, (state) => {
        state.isDeletePopupLoading = true
      })
      .addCase(PopupService.deletePopupAsyncThunk.rejected, (state) => {
        state.isDeletePopupLoading = false
      })
      .addCase(PopupService.deletePopupAsyncThunk.fulfilled, (state) => {
        state.isDeletePopupLoading = false
      })
  }
})

export const { resetPopupState, togglePopupActive, setPopupImage } = slice.actions
export default slice.reducer
